import React from "react";
import Checkout from "./Checkout";

function App() {
  return (
    <div>
      <Checkout />
    </div>
  );
}

export default App;
